// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import starterReducer from "@store/Framework/Store/Starter/StarterReducer";

/* Store Custom Code - Start */
import greifReducer from "@store/Framework/Store/Greif/GreifReducer";

(reducers as any).greif = greifReducer;
/* Store Custom Code - End */

(reducers as any).starter = starterReducer;
